import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from "react";
import { colors } from "@vfit/shared/themes";
import ProgressWrapper from "../ProgressWrapper/ProgressWrapper";
import GlobalContext from "../../context/Global";
import ProgressCtx from "../../context/Progress";
var Progress = function(props) {
    var count = props.count;
    var progressStyles = useContext(GlobalContext).progressStyles;
    var ref = useContext(ProgressCtx), bufferAction = ref.bufferAction, pause = ref.pause;
    var getProgressStyle = function(param) {
        var active = param.active;
        switch(active){
            case 2:
                return {
                    width: "100%"
                };
            case 1:
                return {
                    transform: "scaleX(".concat(count / 100, ")")
                };
            case 0:
                return {
                    width: 0
                };
            default:
                return {
                    width: 0
                };
        }
    };
    var width = props.width, active = props.active;
    return /*#__PURE__*/ _jsx(ProgressWrapper, {
        width: width,
        pause: pause,
        bufferAction: bufferAction,
        children: /*#__PURE__*/ _jsx("div", {
            style: _object_spread({}, styles.inner, progressStyles, getProgressStyle({
                active: active
            }))
        })
    });
};
var styles = {
    inner: {
        background: colors.$e60000,
        height: "100%",
        maxWidth: "100%",
        borderRadius: 2,
        transformOrigin: "center left",
        WebkitBackfaceVisibility: "hidden",
        MozBackfaceVisibility: "hidden",
        msBackfaceVisibility: "hidden",
        backfaceVisibility: "hidden",
        WebkitPerspective: 1000,
        MozPerspective: 1000,
        msPerspective: 1000,
        perspective: 1000
    }
};
export default Progress;
